<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref v-bind:title="$t('login')" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mt-5 mt-md-4 mx-md-auto">
      <form class="login-formx" action="index.html" onsubmit="return false" id="loginform">
        <div class="card m-0 shadow-0 border-0" id="loginContainer">
          <div class="card-body pt-2">
            <div class="text-center mb-2">
              <i class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-pill p-3 mb-2 mt-1"></i>
              <h5 class="mb-0">{{$t('login_title')}}</h5>
              <span class="d-block text-muted">{{$t('login_enter_your_credentials')}}</span>
            </div>
            <div class="alert alert-danger alert-dismissible" v-if="errorMessage != ''">
              <button type="button" class="close" @click="errorMessage = ''"><span>×</span></button>
              {{errorMessage}}
            </div>
            <div class="alert alert-success alert-dismissible" v-if="displayCreateSuccess == true">
              <span class="font-weight-semibold">{{$t('account_created')}}</span>. {{$t('use_your_credential')}}
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="text" class="form-control" v-bind:placeholder="$t('username')" v-model="username" required="">
              <div class="form-control-feedback">
                <i class="icon-user text-muted"></i>
              </div>
            </div>

            <div class="form-group form-group-feedback form-group-feedback-left">
              <input type="password" name="password" class="form-control" v-bind:placeholder="$t('password')" v-model="password" required="">
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
            </div>

            <div class="form-group">
              <button type="submit" class="btn skin primary-button btn-block" @click="authenticate">{{$t('sign_in')}}</button>
            </div>
            <div class="text-center mt-1" v-if="$store.isHideSignInOption()!=='True'">
              <a href="#" @click="openRegister()">{{$t('register')}}</a>
            </div>
            <div class="text-center" v-if="$store.isHideSignInOption()!=='True'">
              <a href="#" @click="openForgotPassword()">{{$t('forgot_password')}}</a>
            </div>
          </div>
        </div>
      </form>

    </modal-no-ref>
    <login-select-site v-bind:siteid="siteid" v-bind:url="url" ref="selectSite"></login-select-site>
    <register-simple v-bind:siteid="siteid" v-bind:querystring="querystring" callingpage="loginvue" v-bind:siteid="siteid" ref="registerModal" @doforgotpassword="openForgotPassword" @success="registerSuccess"></register-simple>

    <forgot-password ref="forgotPasswordModal" @doregister="openRegister"></forgot-password>
    <nux-flow2 ref="nuxFlowModal"></nux-flow2>
    <ticker ref="ticker"></ticker>
  </div>

</template>

<script>
  import NuxFlow2 from "../nux/nux-flow2.vue";
  import Register from "../register/register-simple.vue";
  import ModalNoRef from "../modals/modal-no-ref.vue";
  import ForgotPassword from "./forgot-password.vue";
  import SelectSite from "./login-select-site.vue";
  import ticker from '../common/common-ticker.vue'
  var password = "";
  var username = "";
  var errorMessage = "";
  var doRedirect = true;
  var selectedSite = 0;
  var doCancel = false;
  var displayCreateSuccess = false;

  export default {
    name: "login-default",
    components: {
      ModalNoRef,
      ticker,
      SelectSite,
      NuxFlow2
    },
    props: {
      user: {
        type: String,
        default: ""
      },
      refresh: {
        type: Boolean,
        default: false
      },
      url: {
        type: String,
        default: ""
      },
      state: {
        type: String,
        default: "closed"
      },
      siteid: {
        type: Number,
        default: 1
      },
      sitecode: {
        type: String,
        default: ""
      },
      querystring: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        password,
        username,
        errorMessage,
        doRedirect,
        selectedSite,
        displayCreateSuccess
      };
    },
    methods: {
      dologin() {
        this.$refs.thisModal.open();
      },
      setDoRedirect(val) {
        this.doRedirect = val;
      },
      setSelectedSite(val) {
        this.selectedSite = val;
      },
      openRegister() {
        this.displayCreateSuccess = false;
        this.close();
        this.$refs.registerModal.open();
      },
      openForgotPassword() {
        this.displayCreateSuccess = false;
        this.close();
        this.$refs.forgotPasswordModal.open();
      },
      registerSuccess(url) {//username, password) {        
        //this.displayCreateSuccess = true;
        //this.$refs.thisModal.open();
        //this.username = username;


        //this.password = password;
        //this.authenticate();
        this.close();
        this.$refs.nuxFlowModal.openWithUrl(url);
      },
      async authenticate() {

        var this_context = this;
        if (!$('#loginform').valid())
          return false;

        this.$refs.ticker.start("loginContainer");
        var data = {
          Username: this.username,
          Password: this.password,
          DomainUrl: location.href,
          Querystring: this.querystring,
          Language: this.$i18n.locale,
        };

        try {

          this.$http.post('/authentication/login', data)
            .catch(error => {
              //this_context.errorMessage = error.response.status + " An error occurred";
              this_context.$refs.ticker.end("loginContainer");
              this_context.errorMessage = this.$t('an_error_occured');
            })
            .then(function (response) {


              this_context.errorMessage = "";
              if (response !== undefined) {
                var response = response.data;
                Vue.prototype.$token = response.AccessToken;
                if (response.ReturnCode == 0) {
                  this_context.errorMessage = "Invalid user credentials";
                  this_context.$refs.ticker.end("loginContainer");
                }
                else if (response.ReturnCode == 3) {
                  this_context.errorMessage = response.DetailedMessage;
                  this_context.$refs.ticker.end("loginContainer");
                }
                else if (response.ReturnCode == 1) {

                  if (response.RedirectUrl !== null && response.RedirectUrl !== '') {
                    this_context.close();
                    location.href = response.RedirectUrl;
                  } else {
                    if (this_context.refresh) {
                      this_context.close();
                    }
                    else if (this_context.selectedSite > 0) {
                      this_context.selectSite(this_context.selectedSite, this_context.doRedirect);
                    }
                    else {
                      this_context.selectSite(response.Sites[0].Siteid, this_context.doRedirect);
                      //location.href = location.href;
                    }
                  }
                }
                else if (response.ReturnCode == 2) {                  
                  var autoselected = false;
                  if (this_context.selectedSite != 0 && this_context.refresh) {
                    this_context.selectSite(this_context.selectedSite, this_context.doRedirect);
                    this_context.$refs.ticker.end("loginContainer");
                    this_context.close();
                    autoselected = true;
                  }
                  else {

                    /*
  
                    // Try to match url with available sites
                    for (var i = 0; i < response.Sites.length; i++) {
                      if (autoselected == false && location.pathname.toLowerCase().indexOf(response.Sites[i].RelativePath.toLowerCase()) > -1) {
  
                        autoselected = true;
                        if (!this_context.refresh) {
                          //alert('autoselected, should redirect')
                          this_context.selectSite(response.Sites[i].Siteid, this.doRedirect);
                          //location.href = location.href;
                        }
                        else {
                          //alert('autoselected refresh, should close')
                          this_context.selectSite(response.Sites[i].Siteid);
                          this_context.$refs.ticker.end("loginContainer");
                          this_context.close();
                        }
                      }
                    }
                    */
                  }

                  if (!autoselected) {
                    // Display the select site component
                    this_context.$refs.selectSite.setSites(response.Sites);
                    if (this_context.sitecode != '' && this_context.sitecode != undefined) {
                      this_context.$refs.selectSite.selectSite(this_context.sitecode);
                    }
                    this_context.$refs.selectSite.open();
                    this_context.$refs.ticker.end("loginContainer");
                    this_context.close();
                  }
                }
                else {
                  this_context.errorMessage = "Unknown error";
                  this_context.$refs.ticker.end("loginContainer");
                }
              }
            });
        }
        catch (err) {
          alert('some error:' + err)
          this.$refs.ticker.end("loginContainer");
        }
      },
      async forgotPassword() {
        try {
          var data = {
            username: 'olle'
          };

          this.$http.post('/api/forgotpassword', data).then(async response => {
            var response = response.data;
          }).then((async response => {

          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async selectSite(siteId, doRedirect) {
        //location.href = '/sites/SetSite?id=' + siteId;        
        try {
          var thisContext = this;
          this.$http.get('/Sites/SetSelectedSite?siteid=' + siteId)
            .then(function (response) {
              if (thisContext.url != null && thisContext.url != "") {
                location.href = thisContext.url;
              }
              else if (doRedirect == true) {
                var redirectUrl = response.data;
                location.href = redirectUrl;
              }
            });
        }
        catch (err) {
          alert('some error:' + err)
        }
        
      },
      getTranslatedText() {
        return this.$t('validation_field_success')
      },
      open(selectedSite) {        
        this.initValidation();
        this.$refs.thisModal.open();
        if (selectedSite != null) {
          this.setSelectedSite(selectedSite);
        }
      },
      refreshOpen(site, doredirect) {
        //alert("refreshOpen"+ site);
        if (site != null) {
          this.setSelectedSite(site);
        }
        this.setDoRedirect(false);
        this.refresh = true;
        this.$refs.thisModal.open();
      },
      close() {
        this.$refs.thisModal.close();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      initValidation() {
        var validator = $('#loginform').validate({
          ignore: 'input[type=hidden], .select2-search__field', // ignore hidden fields
          errorClass: 'validation-invalid-label',
          successClass: 'validation-valid-label',
          validClass: 'validation-valid-label',
          highlight: function (element, errorClass) {
            $(element).removeClass(errorClass);
          },
          unhighlight: function (element, errorClass) {
            //element.remove();
            $(element).siblings().forEach(el => {
              if (el.hasClass(errorClass)) {
                el.removeClass(errorClass);
                el.addClass(successClass);
              }
            });
          },
          success: function (label) {
            //label.addClass('validation-valid-label').text(this.getSuccessText); // remove to hide Success message
          },
          showErrors: function (errorMap, errorList) {
            if (this.numberOfInvalids() > 0)
              this.defaultShowErrors();
          },
          // Different components require proper error label placement
          errorPlacement: function (error, element) {

            // Unstyled checkboxes, radios
            if (element.parents().hasClass('form-check')) {
              error.appendTo(element.parents('.form-check').parent());
            }

            // Input with icons and Select2
            else if (element.parents().hasClass('form-group-feedback') || element.hasClass('select2-hidden-accessible')) {
              error.appendTo(element.parent());
            }

            // Input group, styled file input
            else if (element.parent().is('.uniform-uploader, .uniform-select') || element.parents().hasClass('input-group')) {
              error.appendTo(element.parent().parent());
            }

            // Other elements
            else {
              error.insertAfter(element);
            }
          },
          rules: {
            password: {
              minlength: 5,
              required: true,
            }

          },
          messages: {
            username: this.$t('enter_your_username'),
            password: {
              required: this.$t('enter_your_password'),
              minlength: jQuery.validator.format(this.$t('password_minlength'))
            }
          }
        });
      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.$root.$on('display_login', this.open);
      window.$eventBus.$on('refresh_login', this.refreshOpen, false);
      if (this.state == "open") {
        this.open();
      }

    },
    created() {

    },
  };

</script>

<style>
  .validation-valid-label {
    margin: auto;
    margin-bottom: 30px !important;
    padding-bottom: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login-default.vue